import { defaultStockData, StockDto } from "src/dtos/stock/stockDto";
import {
	defaultWmsTransportHeaderDto,
	WmsTransportHeaderDto,
} from "src/dtos/wmsTransport/wmsTransportDto";
/**
 * 재고 현황 테이블 DTO (메인 테이블)
 */
export interface WMS2040_R01HeaderDto extends StockDto {
	compCd: string;
	compNm: string;
	locationCd?: string;
	locationNm?: string;
	currentQty: number;
	itemCost: number;
	stockAmount: number;
}

export const defaultWMS2040_R01HeaderDto: WMS2040_R01HeaderDto = {
	...defaultStockData,
	compCd: '',
	compNm: '',
	logicCenter: '',
	logicCenterNm: '',
	warehouseCd: '',
	warehouseNm: '',
	itemCd: '',
	itemNm: '',
	itemSpec: '',
	locationCd: '',
	locationNm: '',
	itemStatus: '',
	itemUnit: '',
	currentQty: 0,
	itemCost: 0,
	stockAmount: 0,

	insertDt: undefined,
	insertUser: undefined,
	insertForm: undefined,
	updateDt: undefined,
	updateUser: undefined,
	updateForm: undefined,

	isModified: false,
	inserted: false,
};

/**
 * 재고 원장(상세) 테이블 DTO (우측 상세 테이블)
 */
export interface WMS2040_R01DetailDto extends WmsTransportHeaderDto {
	itemNo: string;
	itemCd: string;
	itemNm: string;
	itemSpec: string;
	itemStatus: string;
	cost: number;
	amt: number;
	txDt: string;           // 거래일자
	partnerCd: string;      // 거래처
    partnerNm: string;      // 거래처명
	inQty: number;          // 입고량
	outQty: number;         // 출고량
	balanceQty: number;     // 재고량(잔고)
	txDtDisplay: string;    // 거래일자(표시용)
}

export const defaultWMS2040_R01DetailDto: WMS2040_R01DetailDto = {
	...defaultWmsTransportHeaderDto,

	itemNo: '',
	itemCd: '',
	itemNm: '',
	itemSpec: '',
	itemStatus: '',
	cost: 0,
	amt: 0,

	txDt: '',
	warehouseCd: '',
	warehouseNm: '',
	partnerCd: '',
	partnerNm: '',
	inoutClass: '',
	inQty: 0,
	outQty: 0,
	balanceQty: 0,
	txDtDisplay: '',
	insertDt: undefined,
	insertUser: undefined,
	insertForm: undefined,
	updateDt: undefined,
	updateUser: undefined,
	updateForm: undefined,

	isModified: false,
	inserted: false,
};
